import { render } from "./EmailStatuses.vue?vue&type=template&id=1c997e12&scoped=true"
import script from "./EmailStatuses.vue?vue&type=script&lang=js"
export * from "./EmailStatuses.vue?vue&type=script&lang=js"

import "./EmailStatuses.vue?vue&type=style&index=0&id=1c997e12&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c997e12"]])

export default __exports__